import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/staff')({
	component: RouteComponent,
})

function RouteComponent() {
	return <Outlet />
}
